export default __webpack_public_path__ + "menu-pageManage-icon.528e4c9c117cea8912d1cc47138e9f15.svg";